import React, { useState, Fragment } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import InformationOutline from "mdi-material-ui/InformationOutline";

const parseTransactionId = (id) => {
  switch (id) {
    case "*offer*":
      return {
        title: "Produto oferecido pelo produtor.",
        description: "Este produto foi-te oferecido pelo produtor. Não houve qualquer transação financeira.",
      };

    case "*team*":
      return {
        title: "És membro da equipa.",
        description: "Este produto foi-te oferecido por seres membro da equipa. Não houve qualquer transação financeira.",
      };

    // case "*import*":
    //   return {
    //     title: "Produto importado de outra plataforma.",
    //     description:
    //       "Este produto foi importado de outra plataforma e não houve qualquer transação financeira com a SalesPark.",
    //   };

    default:
      return null;
  }
};

const TransactionInfo = ({ course }) => {
  const [modalInfo, setModalInfo] = useState({ visible: false });

  if (course === undefined || course === null) return null;

  // console.log("course", course);
  const transactionInfoObj = parseTransactionId(course?.transaction_id);
  if (transactionInfoObj === null) return null;

  return (
    <div style={{ padding: 8 }}>
      <Alert
        severity="info"
        action={
          <Button type="button" variant="text" color="info" onClick={() => setModalInfo({ visible: true })}>
            Saber mais
          </Button>
        }
      >
        {transactionInfoObj?.title}
      </Alert>

      <Fragment>
        <Dialog
          open={modalInfo.visible}
          onClose={() => setModalInfo({ visible: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{ className: "sp-modal__paper" }}
        >
          <DialogContent className="sp-modal sp-modal--left">
            <div className="sp-modal__head">
              <span className="sp-modal__icon">
                <InformationOutline />
              </span>
              <h2 id="alert-dialog-title" className="sp-modal__title">
                {course?.title}
              </h2>
            </div>
            <div id="alert-dialog-description" className="sp-modal__body">
              <strong>Motivo pelo qual tens acesso a este produto:</strong>
              <br />
              {transactionInfoObj?.description}
            </div>
          </DialogContent>
          <DialogActions className="sp-modal__actions">
            <button
              type="button"
              className="sp-modal__btn sp-modal__btn--primary"
              onClick={() => setModalInfo({ visible: false })}
            >
              Compreendi
            </button>
          </DialogActions>
        </Dialog>
      </Fragment>
    </div>
  );
};

export default TransactionInfo;
